import { ClientActionTypes, ClientUnsubscribeAction, SpreadsheetUploadIdentifier } from 'api'
import { SpreadsheetUploadActionTypes, SpreadsheetUploadActions } from './spreadsheetUploadActions'

export enum DealPreloadState {
  INITIAL,
  LOADING,
  COMPLETE,
  ERROR
}

interface SpreadsheetUploadStore {
  dealPreloadState: DealPreloadState
}

export const initialState: SpreadsheetUploadStore = {
  dealPreloadState: DealPreloadState.INITIAL
}

export function spreadsheetUploadReducer(
  state: SpreadsheetUploadStore = initialState,
  action: SpreadsheetUploadActions | ClientUnsubscribeAction
): SpreadsheetUploadStore {
  switch (action.type) {
    case ClientActionTypes.UNSUBSCRIBE_MESSAGE:
      if (action.payload.subscriptionIdentifier === SpreadsheetUploadIdentifier.MTE_UPLOAD) {
        return {
          ...state,
          dealPreloadState: DealPreloadState.INITIAL
        }
      }
      return state

    case SpreadsheetUploadActionTypes.MTE_DEALS_UPLOADED_ACTION:
      return {
        ...state,
        dealPreloadState: DealPreloadState.LOADING
      }

    case SpreadsheetUploadActionTypes.MTE_DEALS_SNAPSHOT_RECEIVED_ACTION:
      return {
        ...state,
        dealPreloadState: DealPreloadState.COMPLETE
      }
    case SpreadsheetUploadActionTypes.MTE_DEALS_SNAPSHOT_ERROR_ACTION:
      return {
        ...state,
        dealPreloadState: DealPreloadState.ERROR
      }
    default:
      return state
  }
}
